import axios from 'axios'
import { getToken, clearAuth } from '../utils/userData.js'
import { trackEvent } from '../utils/mixpanel.js'

const API_URL = import.meta.env.VITE_API_URL || ''

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor for adding auth token
api.interceptors.request.use(
  (config) => {
    // Only add the token if Authorization header is not already set
    if (!config.headers.Authorization) {
      const token = getToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for handling errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    trackEvent('Error', {
      error_type: error.response ? 'server' : 'network',
      error_message: error.response?.data?.message || error.message,
      error_code: error.response?.status,
      page_url: window.location.href,
    })
    // Requests that handle their own 401s (e.g. OTP verification during
    // signup) opt out via `skipAuthRedirect: true` in the request config.
    if (error.response?.status === 401 && !error.config?.skipAuthRedirect) {
      // Handle unauthorized access - clear all auth data
      clearAuth()
      // Don't redirect if on auth pages
      if (!window.location.pathname.includes('/auth') && 
          !window.location.pathname.includes('/signup') &&
          !window.location.pathname.includes('/verify')) {
        window.location.href = '/'
      }
    }
    return Promise.reject(error)
  }
)

export default api

